import { Column, Entity, JoinColumn, JoinTable, ManyToOne, OneToOne } from 'typeorm';
import { OrderedModel } from '@nsk-app/models/orderedModel';
import { InformationMoment } from '@nsk-app/models/informationMoment';
import { ActionMoment } from '@nsk-app/models/actionMoment';
import { Phase } from '@nsk-app/models/phase';
import { MediaFile } from '@nsk-app/models/mediaFile';

@Entity({
  orderBy: {
    order: 'ASC'
  }
})
export class Moment extends OrderedModel {

  @Column()
  visible: boolean;

  @Column()
  icon?: MomentIcon;

  @Column()
  title: string;

  @Column()
  text: string;

  @Column({nullable: true})
  media_url: string;

  @Column()
  push: boolean;

  @Column({nullable: true})
  push_day?: number | null;

  @Column({nullable: true})
  push_time?: string | null;

  @Column()
  time_trigger: boolean;

  @Column({nullable: true})
  start_time?: number | null;

  @Column({nullable: true})
  end_time?: number | null;

  @Column()
  phase_id: number;

  @Column({nullable: true, type: 'text'})
  variant_type?: MomentVariant | null;

  @Column({nullable: true, type: 'simple-json'})
  variant?: null | ActionMoment | InformationMoment;

  @Column({nullable: true, unique: false})
  media_id: number | null;

  @ManyToOne(type => Phase, phase => phase.moments, {lazy: true})
  @JoinColumn({name: 'phase_id'})
  phase?: Promise<Phase>;

  @ManyToOne(type => MediaFile, {eager: true})
  @JoinColumn({name: 'media_id'})
  media_file?: MediaFile;

  getVariant<T>(): T {
    return this.variant as any;
  }
}

export enum MomentVariant {
  ActionMoment = 'App\\Models\\ActionMoment',
  InformationMoment = 'App\\Models\\InformationMoment'
}

export enum MomentIcon {
  None = 0,
  Information = 1,
  Check = 2,
  Plus = 3,
  Conversation = 4,
  Search = 5,
  Calendar = 6,
  Clipboard = 7
}

const iconMap = new Map<MomentIcon, string>();
iconMap.set(MomentIcon.None, null);
iconMap.set(MomentIcon.Information, 'information');
iconMap.set(MomentIcon.Check, 'checkmark');
iconMap.set(MomentIcon.Plus, 'add');
iconMap.set(MomentIcon.Conversation, 'chatbubbles');
iconMap.set(MomentIcon.Search, 'search');
iconMap.set(MomentIcon.Calendar, 'calendar');
iconMap.set(MomentIcon.Clipboard, 'clipboard');

const classMap = new Map<MomentIcon, string>();
classMap.set(MomentIcon.None, '');
classMap.set(MomentIcon.Information, 'information');
classMap.set(MomentIcon.Check, 'check');
classMap.set(MomentIcon.Plus, 'plus');
classMap.set(MomentIcon.Conversation, 'conversation');
classMap.set(MomentIcon.Search, 'search');
classMap.set(MomentIcon.Calendar, 'calendar');
classMap.set(MomentIcon.Clipboard, 'clipboard');


export function mapMomentIconType(type: MomentIcon): string {
  return iconMap.get(type);
}

export function mapMomentIconClass(type: MomentIcon): string {
  return classMap.get(type);
}
